import axios from 'axios';

// WMO 코드 → SKY/PTY 변환 (기존 포맷 호환)
export const wmoToSkyPty = (code) => {
    let SKY = "1", PTY = "0";
    if (code <= 1) { SKY = "1"; PTY = "0"; }
    else if (code <= 2) { SKY = "3"; PTY = "0"; }
    else if (code <= 3) { SKY = "4"; PTY = "0"; }
    else if (code <= 48) { SKY = "4"; PTY = "0"; }
    else if (code <= 57) { SKY = "4"; PTY = "1"; }
    else if (code <= 65) { SKY = "4"; PTY = "1"; }
    else if (code <= 67) { SKY = "4"; PTY = "2"; }
    else if (code <= 77) { SKY = "4"; PTY = "3"; }
    else if (code <= 82) { SKY = "4"; PTY = "4"; }
    else if (code <= 86) { SKY = "4"; PTY = "3"; }
    else if (code <= 99) { SKY = "4"; PTY = "4"; }
    return { SKY, PTY };
};

// 단기예보 (Open-Meteo hourly, 5일)
export const getShortWeather = (param, succFun, failFun) => {
    let url = "https://api.open-meteo.com/v1/forecast";
    url += "?latitude=" + param.lat;
    url += "&longitude=" + param.lng;
    url += "&hourly=temperature_2m,relative_humidity_2m,precipitation_probability,precipitation,snowfall,weather_code,wind_speed_10m";
    url += "&timezone=auto";
    url += "&forecast_days=5";

    axios.get(url)
        .then((response) => {
            let timeData = {};
            if (response && response.data && response.data.hourly) {
                let hourly = response.data.hourly;
                for (let i = 0; i < hourly.time.length; i++) {
                    let t = hourly.time[i].replace(/[-T:]/g, "");
                    let key = "D" + t.substring(0, 12);
                    let skyPty = wmoToSkyPty(hourly.weather_code[i]);
                    let windSpeedMs = (hourly.wind_speed_10m[i] / 3.6).toFixed(1);
                    let pcp = hourly.precipitation[i];
                    let pcpStr = pcp > 0 ? pcp + "mm" : "강수없음";
                    let sno = hourly.snowfall[i];
                    let snoStr = sno > 0 ? sno + "cm" : "적설없음";

                    timeData[key] = {
                        TMP: String(Math.round(hourly.temperature_2m[i])),
                        SKY: skyPty.SKY,
                        PTY: skyPty.PTY,
                        POP: String(hourly.precipitation_probability[i] || 0),
                        PCP: pcpStr,
                        SNO: snoStr,
                        REH: String(hourly.relative_humidity_2m[i]),
                        WSD: String(windSpeedMs)
                    };
                }
                succFun(timeData);
            }
        })
        .catch((err) => {
            console.error("Open-Meteo API error:", err);
            if (failFun) failFun(err);
        });
};

// 중기예보 (Open-Meteo daily, 4~7일 후)
export const getDailyForecast = (param, succFun, failFun) => {
    let url = "https://api.open-meteo.com/v1/forecast";
    url += "?latitude=" + param.lat;
    url += "&longitude=" + param.lng;
    url += "&daily=weather_code,temperature_2m_max,temperature_2m_min,precipitation_probability_max";
    url += "&timezone=auto";
    url += "&forecast_days=7";

    axios.get(url)
        .then((response) => {
            if (response && response.data && response.data.daily) {
                let daily = response.data.daily;
                let dataArr = [];
                for (let i = 4; i < 7; i++) {
                    if (i >= daily.time.length) break;
                    let skyPty = wmoToSkyPty(daily.weather_code[i]);
                    let weatherType;
                    if (skyPty.PTY === "0") {
                        if (skyPty.SKY === "1") weatherType = "맑음";
                        else if (skyPty.SKY === "3") weatherType = "구름많음";
                        else weatherType = "흐림";
                    } else if (skyPty.PTY === "1") weatherType = "비";
                    else if (skyPty.PTY === "2") weatherType = "비/눈";
                    else if (skyPty.PTY === "3") weatherType = "눈";
                    else if (skyPty.PTY === "4") weatherType = "소나기";

                    dataArr.push({
                        day: i,
                        rainRate: daily.precipitation_probability_max[i],
                        morning: weatherType,
                        afternoon: weatherType,
                        minTemp: Math.round(daily.temperature_2m_min[i]),
                        maxTemp: Math.round(daily.temperature_2m_max[i])
                    });
                }
                succFun(dataArr);
            }
        })
        .catch((err) => {
            console.error("Open-Meteo daily API error:", err);
            if (failFun) failFun(err);
        });
};
